import React, { createContext } from 'react';

export const PromptToSignInContext = createContext({
  promptToSignIn: (redirectAfterAuth?: string) => {}, // eslint-disable-line @typescript-eslint/no-unused-vars
  closePromptToSignIn: () => {},
  promptOpen: false,
  redirectLink: '/',
  setRedirectLink: (str: string) => {}, // eslint-disable-line @typescript-eslint/no-unused-vars
});

interface Props {
  children: React.ReactNode;
}

export const PromptToSignInProvider = ({ children }: Props) => {
  const [promptOpen, setPromptOpen] = React.useState<boolean>(false);
  const [redirectLink, setRedirectLink] = React.useState<string>('/mypage');

  const promptToSignIn = (redirectAfterAuth?: string) => {
    setPromptOpen(true);
    if (redirectAfterAuth) {
      setRedirectLink(redirectAfterAuth);
    }
  };

  const closePromptToSignIn = () => {
    setPromptOpen(false);
    setRedirectLink('/mypage');
  };

  return (
    <PromptToSignInContext.Provider
      value={{
        promptToSignIn,
        promptOpen,
        closePromptToSignIn,
        redirectLink,
        setRedirectLink,
      }}
    >
      {children}
    </PromptToSignInContext.Provider>
  );
};
